import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  background: ${v2Colors.inputBackground};
  border: 1px solid ${v2Colors.border};
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.12);
  font-family: ${v2FontFamily};
  z-index: 20;

  span {
    display: block;
    padding: 9px 12px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 400;
    color: ${v2Colors.text};
    cursor: pointer;

    &:hover {
      background: ${v2Colors.surface};
    }
  }
`;
